import styled from "styled-components";

export const TradeModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 70;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const TradeModalCard = styled.div`
  width: min(860px, 100%);
  height: 85vh;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
`;

export const TradeModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e8edf2;
  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #101418;
  }
`;

export const TradeModalClose = styled.button`
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #5b6675;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  &:hover {
    background: #f1f4f8;
    color: #101418;
  }
`;

export const TradeTeamSelector = styled.div`
  padding: 12px 20px;
  border-bottom: 1px solid #e8edf2;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #3a4450;
  .select-wrapper {
    min-width: 220px;
  }
`;

export const TradeColumnsWrapper = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const TradeColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  &:first-child {
    border-right: 1px solid #e8edf2;
  }
`;

export const TradeColumnHeader = styled.div`
  padding: 10px 16px;
  border-bottom: 1px solid #e8edf2;
  font-size: 13px;
  font-weight: 700;
  color: #101418;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f9fafb;
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`;

export const TradePlayerList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
`;

export const TradePlayerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid #f3f4f6;
  &:hover {
    background: #f1f4f8;
  }
  &.selected {
    background: #e8f5e9;
  }
  .pos-pill {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    color: rgb(31, 41, 55);
    min-width: 36px;
    text-align: center;
  }
  .player-name {
    flex: 1;
    font-weight: 600;
    color: #1f2937;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .player-rank {
    color: #6b7280;
    min-width: 36px;
    text-align: right;
  }
  .check-icon {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #d1d5db;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    font-size: 11px;
    color: transparent;
    transition: all 0.15s;
  }
  &.selected .check-icon {
    background: #2cba35;
    border-color: #2cba35;
    color: #ffffff;
  }
`;

export const TradeEmptyState = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #9ca3af;
  font-size: 13px;
`;

export const TradeModalFooter = styled.div`
  padding: 14px 20px;
  border-top: 1px solid #e8edf2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  background: #f9fafb;
`;

export const TradeCancelButton = styled.button`
  height: 34px;
  padding: 0 20px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: #f3f4f6;
  }
`;

export const TradeSubmitButton = styled.button`
  height: 34px;
  padding: 0 20px;
  border-radius: 6px;
  border: none;
  background: #2cba35;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    background: #25a02e;
  }
  &:disabled {
    background: #d1d5db;
    color: #9ca3af;
    cursor: not-allowed;
  }
`;

export const ConfirmBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  gap: 20px;
  min-height: 0;
`;

export const ConfirmSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ConfirmSectionTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5b6675;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`;

export const ConfirmPlayerCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e8edf2;
  border-radius: 6px;
  margin-bottom: 6px;
  .pos-pill {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    color: rgb(31, 41, 55);
    min-width: 36px;
    text-align: center;
  }
  .player-name {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: #1f2937;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .player-rank {
    font-size: 12px;
    color: #6b7280;
  }
`;

export const ConfirmDivider = styled.div`
  width: 1px;
  background: #e8edf2;
  flex: none;
`;

export const ConfirmArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 36px;
  font-size: 20px;
  color: #9ca3af;
`;
